const styles = theme => ({
  content: {
    display: 'flex',
    padding: '16px 24px',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
    gap: '16px',
    alignSelf: 'stretch',
    borderRadius: '16px',
    background: 'var(--Background-Light-Paper, #FFF)',
    boxShadow:
      '0px 0px 2px 0px rgba(145, 158, 171, 0.20), 0px 12px 24px -4px rgba(145, 158, 171, 0.12)',
  },
  headerContainer: {
    alignItems: 'center',
    gap: '8px',
    display: 'flex',
  },
  headerText: {
    color: 'var(--mcg-dark, #002E47)',
    fontFamily: 'Inter',
    fontSize: '14px',
    fontStyle: 'normal',
    fontWeight: '500',
    lineHeight: '150%',
  },
  headerTextClose: {
    color: 'var(--mcg-dark, #002E47)',
    fontFamily: 'Inter',
    fontSize: '14px',
    fontStyle: 'normal',
    fontWeight: '400',
    lineHeight: '150%',
  },
  header: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    width: '100%',
  },
  close: {
    display: 'flex',
    gap: '16px',
  },
  icon: {
    width: 20,
    height: 20,
    padding: 1,
    cursor: 'pointer',
  },

  cardTop: {
    height: '90px',
    alignSelf: 'stretch',
    width: '224px',
  },
  cardText: {
    display: 'flex',
    padding: '12px',
    justifyContent: 'center',
    alignItems: 'center',
    alignSelf: 'stretch',
    color: 'var(--Text-Light-Primary, #212B36)',
    fontFamily: 'Inter',
    fontSize: '14px',
    fontStyle: 'normal',
    fontWeight: '400',
    lineHeight: '150%',
  },
  // Buton stilleri
  applyButton: {
    display: 'flex',
    justifyContent: 'center',
    width: '100%',
    backgroundColor: '#FFF',
  },
  applyButtonVisible: {
    position: 'fixed',
    bottom: 0,
    left: 0,
    right: 0,
    backgroundColor: 'transparent',
    zIndex: 1000,
    marginBottom: '40',
  },
  templateContainer: {
    position: 'relative',
    width: '100%',
    display: 'flex',
    alignItems: 'center',
  },
  template: {
    display: 'flex',
    flexDirection: 'row',
    flexWrap: 'nowrap',
    justifyContent: 'flex-start',
    gap: '16px',
    width: '100%',
    overflow: 'hidden',
  },
  navigationArrow: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    minWidth: '40px',
    height: '40px',
    borderRadius: '50%',
    background: 'white',
    boxShadow: '0px 2px 4px rgba(0, 0, 0, 0.1)',
    cursor: 'pointer',
    zIndex: 2,
    '&:hover': {
      background: '#f5f5f5',
    },
  },
  leftArrow: {
    position: 'absolute',
    left: '-20px',
  },
  rightArrow: {
    position: 'absolute',
    right: '-20px',
  },
  disabledArrow: {
    opacity: 0.5,
    cursor: 'not-allowed',
    '&:hover': {
      background: 'white',
    },
  },
  column: {
    flex: '0 0 calc(20% - 16px)',
    minWidth: '200px',
    overflow: 'hidden',
    border: '1px solid #E0E0E0',
    transition: 'all 0.3s ease',
    cursor: 'pointer',
    '&:hover': {
      boxShadow: '0px 4px 8px rgba(0, 0, 0, 0.1)',
      border: '1px solid var(--mcg-blue, #015FFB)',
    },
    borderRadius: '16px',
  },
  templateWrapper: {
    position: 'relative',
    width: '100%',
  },
  navButton: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    width: '40px',
    height: '40px',
    borderRadius: '50%',
    background: '#fff',
    cursor: 'pointer',
    zIndex: 10,
    transition: 'all 0.2s ease',
    position: 'absolute',
    top: '50%',
    transform: 'translateY(-50%)',
    '&:hover': {
      boxShadow: '0px 6px 12px rgba(0, 0, 0, 0.15)',
      background: '#f5f5f5',
    },
  },
  navButtonLeft: {
    left: '-20px', // -20px ile solda şablon konteyneri dışında kalır
  },
  navButtonRight: {
    right: '-20px', // -20px ile sağda şablon konteyneri dışında kalır
  },
  navButtonDisabled: {
    opacity: 0.5,
    cursor: 'not-allowed',
    '&:hover': {
      boxShadow: '0px 4px 8px rgba(0, 0, 0, 0.1)',
      background: '#fff',
    },
  },
  navIcon: {
    color: '#002E47',
  },
  pagination: {
    display: 'flex',
    justifyContent: 'center',
    marginTop: '16px',
  },
  paginationText: {
    fontSize: '14px',
    color: '#002E47',
  },
  template: {
    display: 'flex',
    flexWrap: 'wrap',
    justifyContent: 'center',
    gap: '16px',
    padding: '0 16px',
    position: 'relative',
    transition: 'transform 0.3s ease',
  },
})

export default styles
